<template>

    <button class="btn btn-light" @click="download"><i class="fa fa-download"></i> &nbsp;Download</button>&nbsp;&nbsp;&nbsp;
</template>


<script type="text/babel">

    export default{
        name: "Download",
        data:function(){
            return {
            }
        },
        props:{
            filters: {
                type: Object,
                required: true
            },
            fn: {
                type:String,
                required: true
            },
            cols: {
                type: Array,
                required: true
            }
        },

        methods:{
            download(){
                var data = JSON.parse(JSON.stringify(this.filters));
                data.offset = null;
                data.limit = null;

                var _this = this;

                this.$send(this, this.fn, data).then(r => {
                    if(!response.body.data[this.fn] || !response.body.data[this.fn].length ) {
                        this.$store.commit('setStatus', {
                            status: false,
                            message: "No results found for this search!"
                        });
                        return;
                    }



                    var csv_generator = new window.CSV();

                    var list = response.body.data[this.fn];
                    var output = [];

                    var heading = {};
                    this.cols.forEach(function(c){
                        if(_this.filters.columns.indexOf(c.key) >= 0){
                            heading[c.key] = c.display
                        }
                    });

                    output.push(heading);

                    list.forEach(function(row){
                        var tmpObj = {};
                        _this.cols.forEach(function(c){
                            if(_this.filters.columns.indexOf(c.key) >= 0){
                                tmpObj[c.key] = row[c.key]
                            }
                        });
                        output.push(tmpObj);
                    });

                    var csv = csv_generator.generate(output);
                    var downloadLink = document.createElement("a");
                    var blob = new Blob([csv]);
                    var url = URL.createObjectURL(blob);
                    downloadLink.href = url;
                    downloadLink.download = this.fn + ".csv";

                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                });

/*
                this.$http.post('http://10.0.24.14/api.php', {
                    function: this.fn,
                    data: data
                }, {
                    emulateJSON: true
                }).then(function(response){
                    if(response.body.status){


                        if(!response.body.data[this.fn] || !response.body.data[this.fn].length ) {
                            this.$store.commit('setStatus', {
                                status: false,
                                message: "No results found for this search!"
                            });
                            return;
                        }



                        var csv_generator = new window.CSV();

                        var list = response.body.data[this.fn];
                        var output = [];

                        var heading = {};
                        this.cols.forEach(function(c){
                            if(_this.filters.columns.indexOf(c.key) >= 0){
                                heading[c.key] = c.display
                            }
                        });

                        output.push(heading);

                        list.forEach(function(row){
                            var tmpObj = {};
                            _this.cols.forEach(function(c){
                                if(_this.filters.columns.indexOf(c.key) >= 0){
                                    tmpObj[c.key] = row[c.key]
                                }
                            });
                            output.push(tmpObj);
                        });

                        var csv = csv_generator.generate(output);
                        var downloadLink = document.createElement("a");
                        var blob = new Blob([csv]);
                        var url = URL.createObjectURL(blob);
                        downloadLink.href = url;
                        downloadLink.download = this.fn + ".csv";

                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);


                    } else {
                        this.$store.commit('setStatus', {
                            status: false,
                            message:response.body.message
                        });
                    }
                });
                */
            },
        }
    }


</script>


// WEBPACK FOOTER //
// Download.vue?d7d84342